import { useEffect } from "react";
import { useSelector } from "react-redux";
import { selectThemeMode } from "../app/slices/GlobalSlice";

/**
 * Component that applies the dark class to body element based on Redux theme state
 * This ensures the theme is applied immediately on mount and when it changes
 */
export default function ThemeInitializer() {
  const themeMode = useSelector(selectThemeMode);

  useEffect(() => {
    if (themeMode === "dark") {
      document.body.classList.add("dark");
    } else {
      document.body.classList.remove("dark");
    }
  }, [themeMode]);

  // Also apply on initial mount based on localStorage
  useEffect(() => {
    const stored = localStorage.getItem("themeMode");
    if (stored === "dark") {
      document.body.classList.add("dark");
    } else {
      document.body.classList.remove("dark");
    }
  }, []);

  return null;
}
